import { useState } from 'react';

interface UserProfileCardProps {
  user: {
    firstName?: string;
    lastName?: string;
    balance: number;
  } | null;
  formatCurrency: (amount: number) => string;
  balanceLabel: string;
  subtitle: string;
}

const UserProfileCard = ({ user, formatCurrency, balanceLabel, subtitle }: UserProfileCardProps) => {
  const [isBalanceVisible, setIsBalanceVisible] = useState(true);

  const toggleBalanceVisibility = () => {
    setIsBalanceVisible(!isBalanceVisible);
  };

  const displayBalance = isBalanceVisible 
    ? formatCurrency(user?.balance || 0)
    : '••••••';

  return (
    <div className="mb-6">
      <div className="flex items-center gap-4 mb-4">
        <div className="w-16 h-16 rounded-full bg-primary flex items-center justify-center text-2xl font-bold text-white">
          {user?.firstName?.[0] || 'U'}
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <h2 className="text-xl font-semibold text-white">{user?.firstName} {user?.lastName}</h2>
            {/* <span className="px-2 py-0.5 bg-yellow-500 text-black text-xs font-bold rounded">VIP 1</span> */}
          </div>
          <p className="text-sm text-tg-hint">{subtitle}</p>
        </div>
      </div>
      <div className="flex items-center justify-between bg-tg-secondary rounded-xl p-4 border border-gray-800 hover:border-primary/50 hover:shadow-lg hover:shadow-primary/20 transition-all duration-300">
        <div>
          <div className="text-xs text-tg-hint mb-1">{balanceLabel}</div>
          <div className="text-2xl font-bold text-white">{displayBalance}</div>
        </div>
        <button 
          onClick={toggleBalanceVisibility}
          className="text-tg-hint hover:text-primary hover:scale-110 transition-all duration-300 p-1"
          aria-label={isBalanceVisible ? 'Hide balance' : 'Show balance'}
        >
          {isBalanceVisible ? (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
            </svg>
          ) : (
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.29 3.29m0 0L3 12m3.29-5.71L12 12m-5.71 0L12 12m0 0l3.29 3.29M12 12l3.29-3.29m0 0L21 3m-5.71 5.71L12 12m5.71 0L21 21" />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};

export default UserProfileCard;

